import TrainingCoursePreviewPage from '../TrainingCourses/PreviewPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function CoursePreviewPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('courses.title'),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCoursePreviewPage isTesting={false} />;
}
